import BaseModalStore from '../layout/base-store';
import copy from '@src/components/copy';
import getPageLocalesData from '@src/global-locales/get-page-locales-data';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';

const pageLocalesData = getPageLocalesData();
const mainLocalesData = pageLocalesData.main;

const lang = getLanguageByPath();

class DownloadModalStore extends BaseModalStore {
  name = '下载弹窗';

  copyLink = () => {
    copy(`https://mechabreak.seasungames.com/${lang}/download.html`, {
      successPreText: `${mainLocalesData.giftPackCopyText}`
    });
  };

  use() {
    super.use();
  }
}

export default DownloadModalStore;
